import { IApplicationState } from '../../types/redux';

export const selectIsPromoDetailsOpen = (state: IApplicationState) => {
  return state.promoDetails.isOpen;
};
